import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useHistory } from 'react-router-dom'

import * as styles from './styles'

const TournamentHeaderComponent = ({ event, loading, error, activeTab, onTabChange, eventId }) => {
	const history = useHistory()

	const handleCalendarClick = () => {
		history.push(`/main/events/${eventId}/details`)
	}

	const handleBack = () => {
		history.push('/main/events/')
	}

	if (loading) {
		return (
			<div css={styles.headerContainer}>
				<div css={styles.header}>
					<FontAwesomeIcon
						icon="arrow-left"
						css={styles.backArrow}
						onClick={handleBack}
					/>
					<div css={styles.titleContainer}>
						<Text size={16} bold css={styles.tournamentTitle}>
							Loading...
						</Text>
					</div>
					<FontAwesomeIcon
						icon="calendar-alt"
						css={styles.calendarIconRight}
						onClick={handleCalendarClick}
					/>
				</div>
				<div css={styles.tabsContainer}>
					<div css={styles.tabsWrapper}>
						<div css={styles.loadingTabs}>Loading tabs...</div>
					</div>
				</div>
			</div>
		)
	}

	if (error || !event) {
		return (
			<div css={styles.headerContainer}>
				<div css={styles.header}>
					<FontAwesomeIcon
						icon="arrow-left"
						css={styles.backArrow}
						onClick={handleBack}
					/>
					<div css={styles.titleContainer}>
						<Text size={16} bold css={styles.tournamentTitle}>
							Tournament
						</Text>
					</div>
					<FontAwesomeIcon
						icon="calendar-alt"
						css={styles.calendarIconRight}
						onClick={handleCalendarClick}
					/>
				</div>
			</div>
		)
	}

	const tournament = event.tournament
	const tournamentName = tournament?.tournamentName || 'Tournament'

	return (
		<div css={styles.headerContainer}>
			{/* Header */}
			<div css={styles.header}>
				<FontAwesomeIcon
					icon="arrow-left"
					css={styles.backArrow}
					onClick={handleBack}
				/>
				<div css={styles.titleContainer}>
					<Text size={16} bold css={styles.tournamentTitle}>
						{tournamentName}
					</Text>
				</div>
				<FontAwesomeIcon
					icon="calendar-alt"
					css={styles.calendarIconRight}
					onClick={handleCalendarClick}
				/>
			</div>

			{/* Tabs */}
			<div css={styles.tabsContainer}>
				<div css={styles.tabsWrapper}>
					<button
						css={[styles.tab, activeTab === 'games' && styles.activeTab]}
						onClick={() => onTabChange('games')}
					>
						<Text size={12} bold={activeTab === 'games'} css={[styles.tabText, activeTab === 'games' && styles.activeTabText]}>
							Games
						</Text>
					</button>
					<button
						css={[styles.tab, activeTab === 'teams' && styles.activeTab]}
						onClick={() => onTabChange('teams')}
					>
						<Text size={12} bold={activeTab === 'teams'} css={[styles.tabText, activeTab === 'teams' && styles.activeTabText]}>
							Teams
						</Text>
					</button>
				</div>
			</div>
		</div>
	)
}

TournamentHeaderComponent.propTypes = {
	event: PropTypes.shape({
		tournament: PropTypes.shape({
			id: PropTypes.number,
			tournamentName: PropTypes.string,
			logo: PropTypes.string,
		}),
	}),
	loading: PropTypes.bool,
	error: PropTypes.string,
	activeTab: PropTypes.string.isRequired,
	onTabChange: PropTypes.func.isRequired,
	eventId: PropTypes.number.isRequired,
}

export default TournamentHeaderComponent 